<template>
  <div style="height: calc(100vh - 60px); background: #F2F2F6;overflow:auto">
         <el-breadcrumb  separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>厂家列表</el-breadcrumb-item>
        </el-breadcrumb>
   <el-form size="mini" label-width="130px" :model="where" class="demo-form-inline">
  <el-row>
    <el-col :span="6">
       <el-form-item label="厂家名称">
    <el-input v-model="where.name"></el-input>
  </el-form-item>
    </el-col>
       <el-col :span="6">
       <el-form-item label="所在城市">
      <el-input v-model="where.city"></el-input>
  </el-form-item>
     </el-col>
       <el-col :span="6">
         <el-form-item label="识别码">
           <el-input v-model="where.code"></el-input>
         </el-form-item>
       </el-col>
       <el-col :span="6"> <el-form-item label="所属板商">
        <el-select
         clearable
         filterable
         style="width:100%"
          v-model="where.producerid">
           <el-option  label="非板商厂家" :value="-1" ></el-option>
            <el-option v-for="p in producers" :label="p.name" :value="p.innerid" :key="p.innerid"></el-option>
          </el-select>
       </el-form-item></el-col>
       <el-col :span="6"> <el-form-item label=""></el-form-item></el-col>
       <el-col :span="18" style="text-align:right">

        <el-button size="small" type="primary" @click="searchFactory()">查询</el-button>
          <el-divider  direction="vertical"></el-divider>
          <el-button title="新增厂家" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="createUser()"></el-button>

      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
           height="calc(100% - 237px)"
          @sort-change="sort"
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            width="100"
            :index="indexMethod"
          ></el-table-column>
          <el-table-column prop="name" label="厂家名称"> </el-table-column>
          <el-table-column prop="username" label="识别号/主账号" width="100" > </el-table-column>
          <el-table-column prop="city" width="100" label="所在城市"> </el-table-column>
          <el-table-column prop="createdtime" width="150" label="创建时间"> </el-table-column>
          <el-table-column prop="pname" label="板商"> </el-table-column>
          <el-table-column sortable="custom" prop="total" width="120" label="网关总数"> </el-table-column>
          <el-table-column sortable="custom" prop="one" width="120" label="1年内新增"> </el-table-column>
          <el-table-column sortable="custom"  prop="seven" width="120" label="7天新增"> </el-table-column>
          <el-table-column prop="totalactive" width="120" label="总激活数"> </el-table-column>
           <el-table-column sortable="custom" prop="oneactive" width="120" label="24小时激活"> </el-table-column>
          <el-table-column sortable="custom" prop="sevenactive" width="120" label="7天激活"> </el-table-column>
          <el-table-column  column-key="opt"
            label="操作"
             width="250">
            <template slot-scope="scope">
               <el-button
                size="mini"
                type="text"
                title=""
                @click="$router.push({name:'EditFactory',params:{innerid:scope.row.innerid}})"
                >详情</el-button
              >
                <el-divider  direction="vertical"></el-divider>
                    <el-button  size="mini"
                type="text"
                title=""
                @click="resetPassword(scope.row)"
                >重置密码</el-button
              >
                <el-divider   direction="vertical"></el-divider>
              <el-button
                size="mini"
                type="text"
                title=""
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
    <el-row>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { hex_md5 } from '../../assets/js/md5'
export default {
  name: 'UserList',
  data () {
    return {
      title: 'B端平台权限设置',
      drawer: false,
      user: {},
      tabledata: [],
      pageset: {
        size: 15,
        index: 1
      },
      order: {
        prop: 'createdtime',
        order: 'desc'
      },
      totalsize: 0,
      where: {
        producerid: ''
      },
      permission: null,
      current: null,
      producers: []
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      this.user = JSON.parse(customer)
      Vue.axios
        .post('/producer/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.producers = res.data.msgbody
          } else {
          }
        })
      self.searchFactory()
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    createUser () {
      this.$router.push({name: 'CreateFactory'})
    },
    searchFactory () {
      var self = this
      Vue.axios
        .post('/factory/list', {
          where: this.where,
          pageset: this.pageset,
          order: this.order
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/factory/list/count', {
          where: this.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    sort (val) {
      if (val.column.order) {
        this.order = {
          prop: val.column.property,
          order: val.column.order.replace('ending', '')
        }
      } else {
        this.order = {
          prop: 'createdtime',
          order: 'desc'
        }
      }
      this.searchFactory()
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchFactory()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchFactory()
    },
    handleDelete (row) {
      this.$confirm(
        '确定删除厂家' + row.name + '(' + (row.code || '-') + ')？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/factory/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                self.searchFactory()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    },
    resetPassword (row) {
      this.$prompt('请输入新密码', '密码重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        if (value) {
          var self = this
          Vue.axios
            .post('/factory/password/update', {
              innerid: row.innerid,
              password: hex_md5(value)
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '修改密码成功：' + value
                })
                self.searchFactory()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        }
      }).catch(() => {

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Factory/Index.vue